module.exports = __webpack_public_path__ + "img/blog6-1-x1.0a6fad7a.webp";